import Button from '@orn/shared-web/components/Button/Button';
import Modal from '@orn/shared-web/components/Modal';

interface IStartPhoneVerificationModalProps {
  isOpen: boolean;
  /** Who is being verified, for the copy. */
  name: string;
  /** The number the group text will go to, as the card shows it. */
  phoneNumber: string;
  isStarting: boolean;
  /** Message from a refused start; undefined hides the line. */
  error?: string;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * What happens when a caregiver asks us to prove a loved one's number.
 *
 * It exists because the act is not the one the button implies. "Verify" reads
 * like a code arriving on one handset; this starts a group text carrying three
 * people, and the caregiver has a part to play in it that nobody else can play
 * for them. A caregiver who finds that out only when their phone buzzes has
 * already sent a stranger a message about their family if the number was wrong.
 *
 * Purely presentational — the parent owns the mutation and the number.
 */
const StartPhoneVerificationModal = ({
  isOpen,
  name,
  phoneNumber,
  isStarting,
  error,
  onClose,
  onConfirm,
}: IStartPhoneVerificationModalProps) => {
  return (
    <Modal isOpen={isOpen} onOpenChange={(open) => !open && onClose()} size="sm">
      <Modal.Header onClose={onClose}>Confirm {name}'s number?</Modal.Header>
      <Modal.Body className="gap-5 px-6 pb-6">
        <div className="text-secondary text-sm">
          We'll start a group text between you, {name} at{' '}
          <span className="text-primary font-medium">{phoneNumber}</span>, and Mantle.
        </div>
        {error && <span className="text-error-primary w-full text-sm">{error}</span>}
        <div className="flex w-full justify-end gap-3">
          <Button color="secondary" size="md" onClick={onClose} isDisabled={isStarting}>
            Cancel
          </Button>
          <Button color="primary" size="md" onClick={onConfirm} isLoading={isStarting} showTextWhileLoading>
            {isStarting ? 'Starting' : 'Start verification'}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default StartPhoneVerificationModal;
